import { RequestData } from '@ant-design/pro-components';

import { request } from '@umijs/max';

import { DeleteRequest } from '@/types';

import {
  ApplyOnDeviceRequest,
  ApplyOnDeviceResponse,
  CreateLabelTemplateRequest,
  EditLabelTemplateRequest,
  LabelTemplateResponse,
  LabelTemplatesAnglesResponse,
  ManageLabelTemplateResponse,
} from './types';

export async function getLabelTemplates(): Promise<RequestData<LabelTemplateResponse>> {
  return request('label-templates', {
    method: 'GET',
  });
}

export async function getLabelTemplatesAngles(): Promise<LabelTemplatesAnglesResponse[]> {
  return request('label-templates/angles', {
    method: 'GET',
  });
}

export async function createLabelTemplate(payload: CreateLabelTemplateRequest): Promise<ManageLabelTemplateResponse> {
  const formData = new FormData();

  formData.append('features', JSON.stringify(payload.features));

  payload.images.forEach((image) => {
    formData.append('images', image);
  });

  return request('label-templates', {
    data: formData,
    method: 'POST',
  });
}

export async function editLabelTemplate({ id, ...payload }: EditLabelTemplateRequest): Promise<ManageLabelTemplateResponse> {
  return request(`label-templates/${id}`, {
    data: payload,
    method: 'PATCH',
  });
}

export async function deleteLabelTemplate({ id }: DeleteRequest): Promise<ManageLabelTemplateResponse> {
  return request(`label-templates/${id}`, {
    method: 'DELETE',
  });
}

export async function applyOnDevice(payload: ApplyOnDeviceRequest): Promise<ApplyOnDeviceResponse> {
  return request('label-templates/apply-on-device', {
    data: payload,
    method: 'POST',
  });
}
